import { BarySidebarComponent } from '../sidebar/bary-sidebar.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';
import { BarySidebarAccordionAdminComponent } from '../sidebar/bary-sidebar-accordion-admin/bary-sidebar-accordion-admin.component';
import { BarySidebarAccordionModeratorComponent } from '../sidebar/bary-sidebar-accordion-moderator/bary-sidebar-accordion-moderator.component';
import { BarySidebarAccordionUserComponent } from '../sidebar/bary-sidebar-accordion-user/bary-sidebar-accordion-user.component';
import { BaryDisconnectedNavBarComponent } from '../nav-bar-disconnected/bary-disconnected-nav-bar.component';
import { BaryNavBarComponent } from '../nav-bar/bary-nav-bar.component';
import { NavigationComponent } from './navigation.component';
import { BarySidebarFooterComponent } from '../sidebar/bary-sidebar-footer/bary-sidebar-footer.component';
import { NgModule } from '@angular/core';
import { TranslateDirective } from '../../../directives/translate.directive';
import { BaryIconComponent } from '../../shared/components/bary-icon/bary-icon.component';

@NgModule({
  imports: [RouterModule, SharedModule, TranslateDirective, BaryIconComponent],
  declarations: [
    NavigationComponent,
    BarySidebarComponent,
    BarySidebarAccordionAdminComponent,
    BarySidebarAccordionModeratorComponent,
    BarySidebarAccordionUserComponent,
    BaryNavBarComponent,
    BarySidebarFooterComponent,
    BaryDisconnectedNavBarComponent,
  ],
  exports: [NavigationComponent],
  providers: [],
})
export class NavigationModule {}
